import { Alert, AlertIcon, AlertTitle, Flex } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from "react-i18next";

const IncompleteNotification: React.FC = () => {
    const { t } = useTranslation('common');
    return <Alert status="info">
    <AlertIcon />
    <Flex direction={'column'}>
      <AlertTitle>{t('common:applicantHasNotSubmittedTheirApp')}</AlertTitle>
    </Flex>
  </Alert>;
  };

export default IncompleteNotification;
